import { useEffect, useRef } from "react";
import Hls from "hls.js";

const BunnyVideo = ({ videoUrl }) => {
  //   return (
  //     <div style={{ aspectRatio: "16 / 9", width: "100%" }}>
  //       <iframe
  //         src={videoUrl}
  //         loading="lazy"
  //         allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
  //         allowFullScreen
  //         style={{
  //           border: "0",
  //           width: "100%",
  //           height: "100%",
  //         }}
  //       />
  //     </div>
  //   );

  const videoRef = useRef(null);


  useEffect(() => {
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(videoUrl);
      hls.attachMedia(videoRef.current);
      
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoRef.current?.play().catch(err => {
          console.log("Autoplay failed:", err);
        });
      });

      return () => hls.destroy();
    }
  }, [videoUrl]);

  return <video ref={videoRef} controls style={{ width: "100%" }} />;
};

export default BunnyVideo;
